// Mock data for Photo Booth Guru website

export const products = [
  {
    id: 1,
    name: 'iMIRROR',
    tagline: 'Our Hot Selling Cake',
    description: 'The Premium Upgrade Your Photo Booth Business Deserves',
    fullDescription: `Take your photo booth business to the next level with the all-new Slim Mirror Booth by Photo Booth Guru — a modern, sleek, and high-performance mirror booth designed to impress guests and boost your bookings instantly.

Built with a premium finish, engineered for easy transport, and packed with professional-grade features, this booth is the perfect investment for both new entrepreneurs and established booth owners looking to scale.`,
    features: [
      {
        title: 'Ultra-Slim, Modern Design',
        description: 'A space-saving profile with a stylish aesthetic that stands out at weddings, corporate events, parties, and activations.'
      },
      {
        title: 'Premium Build Quality',
        description: 'Crafted with durable materials, ensuring longevity, stability, and a premium feel your clients will love.'
      },
      {
        title: 'Ready Stock – No Waiting!',
        description: 'Skip long lead times. Get your booth shipped immediately and start generating bookings faster.'
      },
      {
        title: 'Easy to Transport & Operate',
        description: 'Lightweight, event-friendly, and designed for quick setup. Perfect for single-person operation.'
      },
      {
        title: 'PAN India Delivery',
        description: "Wherever your business is located, we'll deliver the Slim Mirror Booth safely and promptly."
      },
      {
        title: 'After-Sales Support & Setup Assistance',
        description: "From installation to event-day guidance, our support team ensures you're fully confident and ready to wow your clients."
      }
    ],
    featured: true,
    image: '/assets/images/products/mirror1.png'
  },
  {
    id: 2,
    name: 'Retro Booth',
    tagline: 'Vintage Charm Meets Modern Photo Magic',
    description: 'Introduce your clients to a timeless crowd-puller with premium wooden finish and cutting-edge technology',
    fullDescription: 'Designed with a premium wooden finish and built for performance, this booth blends vintage elegance with cutting-edge technology to deliver an unforgettable photo experience at every event. Crafted for booth owners who want to stand out, the Retro Booth brings class, reliability, and visual appeal.',
    features: [
      {
        title: 'Stunning Wooden Exterior',
        description: 'Premium craftsmanship with rich wooden texture that instantly enhances the ambience of any event.'
      },
      {
        title: 'Classic Look, Modern Tech',
        description: 'A nostalgic design powered by high-quality camera, lighting, and software for flawless photos every time.'
      },
      {
        title: 'Rock-Solid, Reliable System',
        description: 'Built with durability in mind, ensuring consistent performance at back-to-back events.'
      },
      {
        title: 'Compact & Easy to Transport',
        description: 'Designed for quick assembly and smooth mobility — ideal for solo operators and teams alike.'
      },
      {
        title: 'PAN India Delivery',
        description: 'Your Retro Booth is securely packed and shipped anywhere across India.'
      },
      {
        title: 'After-Sales Support & Setup Assistance',
        description: 'We guide you through installation, configuration, and usage so you\'re ready to deliver premium experiences from day one.'
      }
    ],
    image: '/assets/images/products/retro-booth.jpg'
  },
  {
    id: 3,
    name: 'Photo Room',
    tagline: 'A Complete Enclosed Photo Experience',
    description: 'An immersive, enclosed photo booth setup designed to deliver cinematic-quality photos and a fully private guest experience',
    fullDescription: 'Step into a world of creativity with the Photo Room — an immersive, enclosed photo booth setup designed to deliver cinematic-quality photos and a fully private guest experience. With professional lighting, customizable backdrops, and a clean enclosed design, this setup guarantees stunning pictures, high engagement, and a premium event highlight.',
    features: [
      {
        title: 'Private, Enclosed Setup',
        description: 'Guests can pose freely without the crowd. The enclosed design enhances comfort, creativity, and photo output.'
      },
      {
        title: 'Studio-Grade Lighting & Quality',
        description: 'Equipped with professional lighting to produce crisp, flattering, high-quality photos every single time.'
      },
      {
        title: 'Highly Customizable Interiors',
        description: 'Change backdrops, colours, branding panels, and props to match any event theme.'
      },
      {
        title: 'Premium Build & Stunning Finish',
        description: 'Strong structure, elegant look, and attention to detail make the Photo Room a high-value attraction at any event.'
      },
      {
        title: 'Fast Setup, Easy Operation',
        description: 'Designed for efficiency — set it up quickly and operate with minimal manpower.'
      },
      {
        title: 'PAN India Delivery & Support',
        description: 'Secure delivery anywhere in India with complete after-sales support and setup assistance.'
      }
    ],
    image: '/assets/images/products/photo-room.jpg'
  },
  {
    id: 4,
    name: 'Vintage Booth',
    tagline: 'Classic Aesthetics, Modern Performance',
    description: 'Bring back the charm of old-school photography with beautifully crafted nostalgic design and latest photo technology',
    fullDescription: 'Inspired by film-era cameras and timeless wooden craftsmanship, the Vintage Booth turns every event into an elegant photo experience while delivering high-quality prints and digital outputs your clients will love. Perfect for weddings, receptions, luxury parties, and boutique events, this booth instantly becomes a visual highlight.',
    features: [
      {
        title: 'Authentic Vintage Wooden Design',
        description: 'Handcrafted wooden exterior with a retro finish that adds character and class to any venue.'
      },
      {
        title: 'Modern Camera & Lighting System',
        description: 'Classic look on the outside, professional imaging on the inside — ensuring crisp, studio-quality photos.'
      },
      {
        title: 'Perfect for Elegant & Theme-Based Events',
        description: 'A top choice for rustic weddings, heritage venues, retro-themed functions, and luxury gatherings.'
      },
      {
        title: 'Quick Setup & Easy Operation',
        description: 'Lightweight, mobile, and built for events — ideal for photo booth owners who want seamless execution.'
      },
      {
        title: 'Sturdy Build for Busy Event Days',
        description: 'Durable components ensure consistent, reliable performance across multiple shoots.'
      },
      {
        title: 'PAN India Delivery & Support',
        description: 'Safe shipping across India with installation guidance and complete technical assistance included.'
      }
    ],
    image: '/assets/images/products/vintage-booth.jpg'
  },
  {
    id: 5,
    name: 'SketchME Bot',
    tagline: 'Turn Guests Into Hand-Drawn Art',
    description: 'AI-powered experience that transforms guest photos into beautiful hand-drawn sketches instantly',
    fullDescription: 'Fun, interactive, and visually stunning, the SketchMe Bot combines creativity with cutting-edge tech, making it a showstopper at corporate events, weddings, exhibitions, mall activations, and brand launches. This isn\'t just another photo booth — it\'s an artistic attraction guests can\'t stop talking about.',
    features: [
      {
        title: 'Instant AI Sketch Transformation',
        description: 'Guests pose → AI captures the photo → A beautiful sketch version prints out instantly. A unique keepsake they will cherish.'
      },
      {
        title: 'Massive Engagement & Crowd Puller',
        description: 'People love watching their sketch being generated. Perfect for high-footfall events and brand experiences.'
      },
      {
        title: 'Custom Branding Options',
        description: 'Add logos, messages, event themes, and brand colours to every sketch printout.'
      },
      {
        title: 'Compact, Modern Setup',
        description: 'Small footprint, sleek design, and event-friendly hardware — ideal for any venue.'
      },
      {
        title: 'Perfect for Corporate Activations',
        description: 'Sketch-based souvenirs are highly shareable, boosting brand recall and social media buzz.'
      },
      {
        title: 'Fast, Smooth Operation',
        description: 'Designed for continuous performance at busy events with little to no waiting time. Complete after-sales support included.'
      }
    ],
    image: '/assets/images/products/sketchme-bot.jpg'
  },
  {
    id: 6,
    name: 'Glambot',
    tagline: 'Hollywood-Style Slow-Motion Magic',
    description: 'High-speed robotic camera system that captures stunning cinematic slow-motion videos like celebrity award shows',
    fullDescription: 'Designed for luxury events, weddings, brand launches, fashion shows, and high-profile celebrations, the Glambot turns every guest into a star. With dramatic movements, crystal-clear footage, and instant social-media-ready outputs, it\'s the ultimate showstopper for any upscale event.',
    features: [
      {
        title: 'Cinematic Slow-Motion Video',
        description: 'Capture guests in stunning high-definition slow motion with smooth robotic camera movement — delivering that iconic Hollywood look.'
      },
      {
        title: 'Professional-Grade Motion Arm',
        description: 'Precision-engineered robotic arm delivers dramatic swoops, zooms, and angles that human filming can\'t match.'
      },
      {
        title: 'Instant Social Media Output',
        description: 'Guests receive their edited glam video instantly — perfect for Instagram Reels, Stories, and brand promotions.'
      },
      {
        title: 'High Engagement & Star Appeal',
        description: 'Every guest lines up for their movie moment. A guaranteed crowd puller for luxury and corporate events.'
      },
      {
        title: 'Custom Branding & Overlays',
        description: 'Add logos, event themes, filters, and cinematic effects to elevate the final output.'
      },
      {
        title: 'Designed for High-End Events',
        description: 'A premium highlight for weddings, brand activations, fashion shows, and celebrity-style celebrations. Complete setup assistance included.'
      }
    ],
    image: '/assets/images/products/glambot.jpg'
  },
  {
    id: 7,
    name: 'Time Freeze',
    tagline: 'Capture Stunning 180° Frozen Moments',
    description: 'Cutting-edge multi-camera setup that captures jaw-dropping "frozen-in-time" moments like blockbuster movies',
    fullDescription: 'With multiple cameras firing at the exact same millisecond, Time Freeze creates a dynamic bullet-time effect that guests absolutely love. It\'s visually striking, highly shareable, and guaranteed to be the star attraction at any premium event. Perfect for corporate activations, mall events, brand launches, weddings, concerts, and large-scale celebrations.',
    features: [
      {
        title: 'True Multi-Camera Bullet-Time Effect',
        description: 'Multiple cameras capture different angles simultaneously, creating an extraordinary 3D frozen moment.'
      },
      {
        title: 'Instant Output With Custom Branding',
        description: 'Guests receive their edited freeze video instantly — complete with logos, event themes, overlays, and brand elements.'
      },
      {
        title: 'High Engagement & Visual Impact',
        description: 'The setup itself draws crowds. The output makes guests go "WOW." Perfect combination of tech + entertainment.'
      },
      {
        title: 'Perfect for Big Stages & Premium Activations',
        description: 'Designed for high footfall and visually rich events that need a strong attraction.'
      },
      {
        title: 'Studio-Grade Lighting',
        description: 'Optimised light placement ensures every freeze frame is crisp, dynamic, and cinematic.'
      },
      {
        title: 'Scalable Multi-Camera Setup',
        description: 'From compact configurations to large 12 camera arcs. Complete after-sales support and setup guidance included.'
      }
    ],
    image: '/assets/images/products/time-freeze.jpg'
  }
];

export const workshops = [
  {
    id: 1,
    title: 'Journey of Inkfly',
    date: 'TBA',
    duration: '3 Hours',
    mode: 'Online',
    description: 'Discover the inspiring story of Inkfly Photo Booth and learn from 13+ years of industry experience',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 2,
    title: 'DIY Booth for Beginners',
    date: 'TBA',
    duration: '4 Hours',
    mode: 'Offline',
    description: 'Learn to build your own photo booth from scratch with hands-on guidance',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 3,
    title: 'AI Photo Booth',
    date: 'TBA',
    duration: '4 Hours',
    mode: 'Offline',
    description: 'Master AI-powered photo booth technology and creative applications for modern events',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 4,
    title: 'Digital Caricature',
    date: 'TBA',
    duration: '3 Hours',
    mode: 'Online/Offline',
    description: 'Create stunning digital caricatures and integrate them into your photo booth offerings',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 5,
    title: 'Gold Edition - Time Freeze',
    date: 'TBA',
    duration: '1 Day',
    mode: 'Offline',
    description: 'Master the art of bullet-time photography with multi-camera Time Freeze setup',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 6,
    title: 'Gold Edition - Flip Photo',
    date: 'TBA',
    duration: '4 Hours',
    mode: 'Offline',
    description: 'Learn advanced flip photo techniques and create engaging dynamic photo experiences',
    price: 'To be announced',
    seats: 'Limited'
  },
  {
    id: 7,
    title: 'Gold Edition - Photo Mosaic',
    date: 'TBA',
    duration: '4 Hours',
    mode: 'Offline',
    description: 'Create stunning photo mosaic installations and integrate them into events',
    price: 'To be announced',
    seats: 'Limited'
  }
];

export const knowledgeArticles = [
  {
    id: 1,
    title: 'Why Choose Photo Booth Guru?',
    subtitle: 'The Trusted Partner for Photo Booth Entrepreneurs Across India',
    excerpt: 'Starting or growing a photo booth business is not just about buying equipment — it\'s about choosing a partner who supports your long-term goals and helps you build a sustainable, profitable business.',
    content: `Over the years, we've helped hundreds of entrepreneurs, photographers, and event companies across India launch and scale their photo booth business successfully. Our approach is simple: Premium products + Practical training + Real-world guidance + Lifetime support.

Starting or growing a photo booth business is not just about buying equipment — it's about choosing a partner who understands the events industry, supports your long-term goals, and helps you build a sustainable, profitable business.

That's where Photo Booth Guru stands apart. We don't just sell booths — we build entrepreneurs. Every booth purchase includes training on setup, operation, event flow, marketing guidance, pricing suggestions, templates, workflow tips, lead generation strategies, and access to a supportive community.`,
    highlights: [
      'We Build Entrepreneurs - Not just customers. Complete training, marketing guidance, pricing strategies, templates, and community access included.',
      'Industry-Leading Designs - Durable, easy to transport, fast setup, event-friendly, and visually premium booths tested extensively before delivery.',
      'Real-Time After-Sales Support - WhatsApp assistance, video troubleshooting, setup guidance, on-site support, software training, and print setup help.',
      'Ready Stock + PAN India Delivery - No waiting. All booths available in ready stock with secure shipping across India.',
      'Designed for Profitability - Revenue-optimized booths that attract premium clients, deliver faster outputs, and generate repeat business.',
      'Trusted by 500+ Owners - Wedding photographers, event planners, corporate companies, mall agencies, freelancers, and production houses.',
      'Real Mentorship from Event Professionals - Practical guidance on pricing, negotiation, peak-season management, client expectations, and strategic scaling.',
      'Innovation-Driven Experiences - AI-driven outputs, interactive booths, Glambot, Time Freeze, SketchMe Bot, and trending solutions.',
      'Transparency & Long-Term Relationships - Honest suggestions based on your budget, target market, city demand, growth plan, and skill level.'
    ],
    date: '2025-08-01',
    image: '/assets/images/knowledge/knowledge-1.jpg'
  },
  {
    id: 2,
    title: 'Start a Photo Booth Business with Zero Knowledge',
    subtitle: 'Looking to Start a Photo Booth Business with Zero Knowledge? We Are Here to Help You',
    excerpt: 'Starting a photo booth business has become one of the most profitable and beginner-friendly opportunities in India\'s booming events industry. No experience? No problem!',
    content: `Starting a photo booth business has become one of the most profitable and beginner-friendly opportunities in India's booming events industry. Whether you're a photographer, freelancer, event planner, or someone looking for a part-time or full-time business — photo booths offer a high-return, low-maintenance, and highly scalable service.

But what if you have zero experience? No technical skills? No background in photography? No idea how to start?

That's exactly where Photo Booth Guru comes in. We've helped hundreds of beginners across India launch their photo booth business from scratch — even those who had never touched a camera or worked at an event before.`,
    highlights: [
      'Complete Step-by-Step Beginner Training - Setup, operation, software, print templates, lighting, guest handling, troubleshooting, and transportation. Ready for your first event within a week.',
      'Business Guidance From Day One - Pricing, pitching to clients, event packages, inquiry handling, Instagram marketing, getting first bookings, and scaling strategies.',
      'Beginner-Friendly Booth Options - Slim Mirror Booth (iMirror), Retro Booth, Vintage Booth, 360 Booth, SketchMe Bot — chosen based on budget, city demand, and target customers.',
      'Ready-to-Start Business Kit Included - Software, ready-to-use templates, business pricing guide, marketing samples, branding guidance, and event checklist.',
      'Lifetime Support — You\'re Never Alone - WhatsApp, phone, video call, and remote troubleshooting support whenever you need help.',
      'Hundreds of Beginners Have Already Started Successfully - Students, IT employees, photographers, event planners, homemakers, freelancers, and career switchers now run their own photo booth businesses.',
      'A Business That Grows as You Grow - Start with one booth, then expand to 360 booth, Glambot, SketchMe Bot, Time Freeze, and AI photo experiences.'
    ],
    date: '2025-07-28',
    image: '/assets/images/knowledge/knowledge-2.jpg'
  },
  {
    id: 3,
    title: 'Learn from the Masters – Join Our Mentorship Program',
    subtitle: 'Join Our Photo Booth Mentorship Program',
    excerpt: 'The difference between a struggling business and a successful one is the right guidance. Learn how to run a profitable business with expert mentorship.',
    content: `In the growing world of photo booths, one thing has become clear: The difference between a struggling business and a successful one is the right guidance.

You can buy a booth anywhere. But learning how to run a profitable business, how to brand yourself, how to price confidently, and how to handle events — that requires real mentorship.

And that is exactly what the Photo Booth Guru Mentorship Program delivers. Whether you're a beginner or an experienced booth owner, our mentorship helps you grow faster, avoid mistakes, and build a strong business foundation.

Without proper guidance, many new entrepreneurs undercharge, make operational mistakes, fail to market themselves, don't know how to talk to clients, lose bookings to competitors, and struggle to scale beyond a few events. Our mentorship program exists to eliminate these problems entirely.`,
    highlights: [
      'Business Basics for Beginners - Understand how the industry works, pricing structures, event flow, and customer expectations.',
      'Marketing & Branding Strategies - Build brand identity, create professional portfolio, use Instagram effectively, generate leads consistently, run ads efficiently, and position as premium provider.',
      'Client Handling & Communication - Learn correct way to talk to clients, close deals, present packages, follow up professionally, and convert inquiries into bookings.',
      'Event Day Mastery - Real-world guidance on setup plans, lighting techniques, on-spot issues, guest management, smooth event flow, speed, and efficiency.',
      'How to Scale Your Business - When to add more booths, how to hire assistants, manage multiple events, increase prices strategically, and build long-term brand.',
      'Lifetime Community Access - Join a tribe of booth owners across India sharing ideas, solutions, and opportunities.',
      'Learn From Real Experience - We don\'t teach theory, we teach experience from managing high-end events, top brands, weddings, corporate shows, and mall activations.',
      'The Fastest Path to Success - Get shortcuts that save time, money, stress, and errors. Learn through expert experience instead of costly mistakes.'
    ],
    date: '2025-07-25',
    image: '/assets/images/knowledge/knowledge-3.jpg'
  }
];

export const contactInfo = {
  phones: ['+91 9841433422', '+91 9952075664'],
  email: 'thepbguru@gmail.com',
  whatsapp: '+91 8754201238',
  social: {
    instagram: 'https://www.instagram.com/thepbg/',
    youtube: 'https://www.youtube.com/@PhotoBoothGuru',
    linkedin: 'https://www.linkedin.com/company/tpbguru/'
  }
};